import React, { useState,useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "./contexts/AuthContext";
import { useConfig } from "./config";
import "./Login.css";

function Login() {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const { config,getVersionedAssetUrl } = useConfig();
  
  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    if (userId) {
      //console.log("User ID found in localStorage, navigating to hr");
      navigate("/hr"); // Navigate to the demobot1 URL
    }
  }, [navigate]);

  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = getVersionedAssetUrl('Login.css');
    document.head.appendChild(link);
    return () => document.head.removeChild(link);
  }, [getVersionedAssetUrl]);

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    const fetchUsers = async () => {
    const response = await fetch(`${config.API_BASE_URL}/api/admin/users/${userId}`);

    // For testing, don't redirect to login
    if (!response.ok) {
      const errorData = await response.json();
      //console.error("Error fetching users:", errorData);
      // Return empty array instead of throwing error
      return [];
    }

    const data = await response.json();
    //console.log("User data:", data);
    if (data.length > 0){
      const response = await fetch(`${config.API_BASE_URL}/api/auth/user_assistant/${data[0].email}`);
      const user_assistant_data = await response.json();
      //console.log("User assistant data:", user_assistant_data);
      if (user_assistant_data.length > 0){
        localStorage.setItem("user_assistant_id", user_assistant_data[0].assistant_id);
        localStorage.setItem("user_assistant_name", user_assistant_data[0].assistant_name);
      }
    }
    
    return ;
  };
  fetchUsers();
  }, []);

  // Get the redirect URL from the location state
  // This is set when a user is redirected to the login page from a protected route
  const from = location.state?.from?.pathname || "/";

  //console.log("Redirect URL from location state:", from);

  const Submit = async (e) => {
    e.preventDefault();
    
    // Get the form element
    const form = document.querySelector('.login-form');
    
    // Get the email input value
    const email = form.querySelector('#email').value;
    
    //console.log("Email:", email);
    
    setIsSubmitting(true);
    try {
      //console.log("Sending redirect URL to backend:", from);
      await login(email, from);
      try {
        const response = await fetch(`${config.API_BASE_URL}/api/auth/generate-magic-link?email=${encodeURIComponent(email)}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        });
  
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.detail || 'Failed to generate magic link');
        }
  
        const data = await response.json();
        //console.log("Magic link data:", data);
        if (data.magic_link){
          let get_token = data.magic_link.split("?token=")[1];
          navigate(`/hr`);
        }
        } catch (error) {
            //console.error('Error generating magic link:', error);
            throw error;
        }
    } catch (error) {
      //console.error("Login error:", error);
      // Add error handling here
    } finally {
      setIsSubmitting(false);
    }
  };

  
    const microsoftLoginWPBrigade = async () => {
      window.location.href = `${config.API_BASE_URL}/api/auth/microsoft-login?org=wpbrigade`;
    };

    return (
      <div className="login-container">
        <div className="login-card">
          <div className="login-header">

            <h2>Welcome Back</h2>
            <p className="login-description">
              Enter your email address to receive a login link
            </p>
          </div>

          <form className="login-form" onSubmit={Submit}>
            <div className="form-group">
              <label htmlFor="email">Email address</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                required
              />
            </div>

            <button
              type="submit"
              className="login-button"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Sending..." : "Send login link"}
            </button>
          </form>
  
          {/* <button
          onClick={microsoftLoginWPBrigade}
          className="microsoft-login-button"
        > */
          /* <div className="microsoft-icon">
            <svg width="21" height="21" viewBox="0 0 21 21">
              <path d="M1 1h9v9H1V1z" fill="#f25022"/>
              <path d="M11 1h9v9h-9V1z" fill="#00a4ef"/>
              <path d="M1 11h9v9H1v-9z" fill="#7fba00"/>
              <path d="M11 11h9v9h-9v-9z" fill="#ffb900"/>
            </svg>
          </div>
          Sign in with Microsoft
        </button> */}

        </div>
      </div>
    );
}

export default Login;
